export default "__VITE_ASSET__01c33996__"